
export function formatDate(date: Date, sep: string = '') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // miesiące są indeksowane od 0
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${sep} ${hours}:${minutes}:${seconds}`;
}


export function formatDateOnly(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // miesiące są indeksowane od 0
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function getRandomTimeBetween8And10() {
    const date = new Date();
    const minHour = 8;
    const maxHour = 10;

    // Generate a random hour between 8 and 10
    const randomHour = Math.floor(Math.random() * (maxHour - minHour + 1)) + minHour;

    // Generate random minutes and seconds
    const randomMinutes = Math.floor(Math.random() * 60);
    const randomSeconds = Math.floor(Math.random() * 60);

    // Set the random time to the date object
    date.setHours(randomHour, randomMinutes, randomSeconds, 0);

    return date;
}

export function getRandomTimeBetween18And20() {
    const date = new Date();
    const minHour = 18;
    const maxHour = 20;

    // Generate a random hour between 8 and 10
    const randomHour = Math.floor(Math.random() * (maxHour - minHour + 1)) + minHour;

    // Generate random minutes and seconds
    const randomMinutes = Math.floor(Math.random() * 60);
    const randomSeconds = Math.floor(Math.random() * 60);

    // Set the random time to the date object
    date.setHours(randomHour, randomMinutes, randomSeconds, 0);

    return date;
}

export function calculateTimeDifference(date1: Date, date2: Date) {
    // Oblicz różnicę w milisekundach
    const differenceInMilliseconds = Math.abs(date2 - date1);
    return formatTimeDifference(differenceInMilliseconds)
}

export function formatTimeDifference(differenceInMilliseconds: number) {
    // Przelicz różnicę na sekundy
    const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);

    // Oblicz godziny, minuty i sekundy
    const hours = Math.floor(differenceInSeconds / 3600);
    const minutes = Math.floor((differenceInSeconds % 3600) / 60);
    const seconds = differenceInSeconds % 60;

    // Formatowanie wyniku
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedHours}h ${formattedMinutes}m ${formattedSeconds}s`;
}

export function calcDeltaTime(startCharging: Date, endCharging: Date) {
    const now = new Date();
    if (now < endCharging) {
        endCharging = now
    }
    return calculateTimeDifference(endCharging, startCharging)
}

export function yesterday(hour: number, minutes: number, seconds: number): Date {
    const currentDate = new Date()
    const yesterday = new Date(currentDate)
    yesterday.setDate(currentDate.getDate() - 1)
    yesterday.setHours(hour)
    yesterday.setMinutes(minutes)
    yesterday.setSeconds(seconds);
    yesterday.setMilliseconds(0);
    return yesterday
}

export function calcDaysToDate(targetDate: string | Date): number {
    const today = new Date();
    const date = new Date(targetDate);

    // Reset time to midnight to ensure clean day difference
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const diffTime = date.getTime() - today.getTime();
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
}

export const getTodayRange = () => {
  const now = new Date();

  // Start of today (00:00:00.000)
  const from = new Date(now);
  from.setHours(0, 0, 0, 0);

  // End of today (23:59:59.999)
  const to = new Date(now);
  to.setHours(23, 59, 59, 999);

  return { from, now, to };
};

export interface DHM { 
    days: number
    hours: number
    minutes: number
}

export function secondsToDHM(seconds: number): DHM {
  const days = Math.floor(seconds / (24 * 3600));
  seconds %= 24 * 3600;
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  return { days, hours, minutes };
}

export function toLocalISOString(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  const tzOffset = -date.getTimezoneOffset(); // minutes
  const sign = tzOffset >= 0 ? '+' : '-';

  const tzHours = pad(Math.floor(Math.abs(tzOffset) / 60));
  const tzMinutes = pad(Math.abs(tzOffset) % 60);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${tzHours}:${tzMinutes}`;
}
// Time zone (IANA name) used by the server to calculate daily statistics and reports.
export function getServerTimeZone(): string | null {
  return window.document.body.getAttribute('data-timezone') || null
}

export function getBrowserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

// True when the server calculates reports for another time zone than the browser uses.
export function isBrowserTimeZoneDifferent(): boolean {
  const serverTimeZone = getServerTimeZone()
  return serverTimeZone !== null && serverTimeZone !== getBrowserTimeZone()
}

// The first day (local midnight) reports can be generated for, or null if there is no limit.
export function getReportsFromDay(): Date | null {
  const value = window.document.body.getAttribute('data-reports-from-day')
  const match = value ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value) : null
  if (!match) {
    return null
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

// Moves a default report period so it does not start before the reports from day.
export function withReportsFromDay<T extends { from: Date, to: Date }>(period: T): T {
  const fromDay = getReportsFromDay()
  if (!fromDay || period.from >= fromDay) {
    return period
  }
  const from = new Date(fromDay)
  let to = period.to
  if (to < from) {
    to = new Date(from)
    to.setHours(23, 59, 0, 0)
  }
  return { ...period, from, to }
}
